import { useAppSelector } from 'hooks/useAppSelector';
import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { dismissNotification } from 'state/notifications/notification.action';
import { getUserNotifications } from 'state/notifications/notification.selector';

import { NotificationListComponent } from './NotificationList';

export const NotificationList: FC = () => {
  const notifications = useAppSelector(state => getUserNotifications(state));
  const dispatch = useDispatch();
  const onDismissNotification = useCallback(
    (id: string) => {
      dispatch(dismissNotification(id));
    },
    [dispatch],
  );
  return <NotificationListComponent notifications={notifications} onClose={onDismissNotification} />;
};
